export const FIELDS = Object.freeze({
  OPACITY: 30,
  COLOR: {
    BACKGROUND: '#000000',
    TEXT: '#FFFFFF',
  },
  NAME: {
    BACKGROUND: 'Background',
  },
  TYPE: {
    TEXT: 'text',
    IMAGE: 'image',
  },
});

export const REGIONS_KEYS = Object.freeze({
  background: 'Background',
  textRegionOne: 'Text Region 1',
  textRegionTwo: 'Text Region 2',
  imageRegionOne: 'Image Region 1',
});
